<ng-container>
  <label *ngIf="label" class="mu-field-label">
    {{ 'form.label.' + label | translate }}
    {{ required ? '*' : '' }}
  </label>
  <span
    *ngIf="tooltipText"
    mu-icon
    [pTooltip]="tooltipText | translate"
    tooltipPosition="top"
    tooltipStyleClass="mu-tooltip-large mu-tooltip"
    class="mu-field-tooltip"
    ><i class="mu-icon mu-icon-info-circle" aria-hidden="true"></i
  ></span>
  <i *ngIf="iconFeedback" [ngClass]="{ 'mu-icon-no-label': !label }" class="fas fa-times-circle mu-error-input" aria-hidden="true"></i>
  <i *ngIf="iconFeedback" [ngClass]="{ 'mu-icon-no-label': !label }" class="fas fa-check-circle mu-succes-input" aria-hidden="true"></i>

  <ng-content></ng-content>
  <app-loading [showLoading]="showLoading" type="input"></app-loading>
  <div class="error" id="errorFormControl-{{ label || customId }}" translate *ngIf="!hideError"></div>
</ng-container>
